import type React from 'react';
import { ProductExportButton } from './ProductExportButton';
import { ProductExportNotice } from './ProductExportNotice';
import type { ProductExportState } from './useProductExport';

type ProductExportViewProps = ProductExportState;

/**
 * The button, in the toolbar's row, and the notice, which places itself in
 * the bottom right corner wherever it sits in the page.
 */
export const ProductExportView: React.FC<ProductExportViewProps> = ({
    isDisabled,
    isExporting,
    filterLines,
    onExport,
    notice,
    onDismissNotice,
}) => (
    <>
        <ProductExportButton
            filterLines={filterLines}
            isDisabled={isDisabled}
            isExporting={isExporting}
            onExport={onExport}
        />
        <ProductExportNotice notice={notice} onDismiss={onDismissNotice} />
    </>
);
